import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getAssociations = async () => {
  const response = await axios.get(`${base_url}associations/getAssociations`);
 
  return response.data;
  
};
const createAssociations = async (formData) => {
  const response = await axios.post(`${base_url}associations/register`, formData);

  return response.data;
};
const updateAssociation = async (News) => {
  const formData = new FormData();
  formData.append("name", News.NewsData.get("name"));
  formData.append("shortName", News.NewsData.get("shortName"));
  formData.append("type", News.NewsData.get("type"));
  formData.append("email", News.NewsData.get("email"));
  formData.append("password", News.NewsData.get("password"));
  formData.append("image", News.NewsData.get("image"));

  const response = await axios.put(
    `${base_url}associations/editAssociation/${News.id}`,
    formData,
    config
  );

  return response.data;
};

const getAssociation = async (id) => {
  const response = await axios.get(`${base_url}associations/getById/${id}`, config);

  return response.data;
};

const deleteAssociation = async (id) => {
  const response = await axios.delete(`${base_url}associations/deleteAssociation/${id}`, config);

  return response.data;
};
const AssociationService = {
  getAssociations,
  createAssociations,
  getAssociation,
  updateAssociation,
  deleteAssociation,
};

export default AssociationService;
